export const EMBED_DEFAULT_CONFIG = {
    name        : 'Embed View',
    icon        : 'i5-embeded-code',
    iconSvg     : 'isvg-embed',
    description : 'Embed any web content by URL or custom embed code',
    projectIcon : 'embed'
}
